var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArrivalStationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_635_3080)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0881 1.6167C16.8993 0.611176 19.1012 0.611175 20.9125 1.6167L31.1245 7.28583C33.0302 8.34378 34.2123 10.352 34.2123 12.5317V23.4683C34.2123 25.648 33.0302 27.6562 31.1245 28.7142L20.9125 34.3833C19.1012 35.3888 16.8993 35.3888 15.0881 34.3833L4.87607 28.7142C2.97036 27.6562 1.78828 25.648 1.78828 23.4683V12.5317C1.78828 10.352 2.97035 8.34378 4.87607 7.28583L15.0881 1.6167Z",
    fill: "#585858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6435 17.3359V18.2266H13.4677V20.793H17.7451V21.707H8.13568V20.793H12.3662V18.2266H9.331V13.3047H16.5497V14.207H10.4443V17.3359H16.6435ZM21.9465 14.7695C21.9465 16.0059 22.8957 17.1777 24.5012 17.6289L23.9738 18.5195C22.7726 18.1562 21.8762 17.3887 21.4133 16.416C20.9504 17.4824 20.0363 18.3145 18.8058 18.707L18.2551 17.8398C19.8605 17.3535 20.8449 16.1113 20.8449 14.7695V14.6172H18.5597V13.7266H20.8449V12.4609H21.9582V13.7266H24.2316V14.6172H21.9465V14.7695ZM19.5793 20.3242V19.4219H26.5168V23.0078H25.4035V20.3242H19.5793ZM25.4035 18.918V12.4961H26.5168V15.2266H28.0402V16.1758H26.5168V18.918H25.4035Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_635_3080"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrivalStationIcon);
export default __webpack_public_path__ + "static/media/ic_arrival_station_icon.ea13af9ed4b1788e4c2b71b8a8c4a1db.svg";
export { ForwardRef as ReactComponent };